import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';

const classNames = require('classnames/bind');
const ID_PREFIX = 'OWA';
export default function trySetIdAndClassName(anchorElement: HTMLAnchorElement) {
    if (!anchorElement.id || anchorElement.id.length === 0) {
        anchorElement.id = ID_PREFIX + Math.round(Math.random() * 1000000).toString();
    }
    if (anchorElement.className.indexOf(OWA_AUTO_LINKS_CLASSNAME) !== -1) {
        return;
    }

    anchorElement.className = classNames(anchorElement.className, OWA_AUTO_LINKS_CLASSNAME);
}
